import React, { h } from "preact";
import { EdgesSelectorSvg } from "./index";

const Svg: React.FunctionalComponent = ({
  children,
}: React.RenderableProps): JSX.Element => (
  <svg viewBox="0 0 398 174" xmlns="http://www.w3.org/2000/svg">
    {children}
  </svg>
);

export default Svg;
